module.exports = __webpack_public_path__ + "static/img/chain-transcation-num.0d7d9d6d.png";